<template>
    <div>
        <!--<el-button class="btn-default" @click="onReset('formInline')">返回</el-button>-->
        <div class="hb">
			<button class="white_but but" @click="onReset()">返回</button>
		</div>
        <!--overflow-y: auto;max-height: 560px;-->
        <div class="ftui-msg-content" style="padding-bottom: 100px;">
            <p class="title bg">{{detailData.scorePolicyName}}</p>
            <div class="timeBox">
                <span>机构名称：</span>
                <i style="margin-right: 50px;">{{detailData.orgName}}</i>
                <span>评测日期：</span>
                <i style="margin-right: 50px;">{{detailData.scoreTimeStr}}</i>
                <span>评测月份：</span>
                <i>{{detailData.scoreDateRange}}</i>
            </div>
            <table class="content">
                <thead>
                    <tr class="bg">
                        <th>评测内容</th>
                        <th>评测指标</th>
                        <th>打分规则</th>
                        <th>评测分值</th>
                        <th>评测得分</th>
                    </tr>
                </thead>
                <tbody id='table_main'>
                    <template v-for='(list,num) in detailItems'>
                        <tr class="bg">
                            <td colspan="1" style="padding: 0px;border-right: none;"><span class="titleBg">{{list.categoryName}}</span></td>
                            <td colspan="4"></td>
                        </tr>
                        <tr v-for='(val,num) in list.item'>
                            <td><span style="position: relative;">{{val.categoryItemName}}
                                <template v-if="val.note!=undefined&&val.note!=''">
                                    <el-tooltip placement="bottom-start">
                                        <div slot="content" class="explainTitle">{{val.note}}</div>
                                        <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
                                    </el-tooltip>
                                </template>
                            </span></td>
                            <td>{{val.targetName}}</td>
                            <td>{{val.ruleName}}</td>
                            <td>{{val.itemTotalScore}}</td>
                            <td>{{val.score}}</td>
                        </tr>
                    </template>
                    <tr class='bg'>
                        <td colspan="3">总计</td>
                        <td>{{detailData.totalScore}}</td>
                        <td>{{detailData.score}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import {MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  name: '',
  data () {
    return {
      detailData: {},
      detailItems: []
    }
  },
  created () {
    var that = this
    var param = {}
    param.id = that.$route.params.id
    api.post(config.khsHost + 'spv/policy/hhs/getScoreDetail.do', param).then(function (response) {
      var categoryId = ''
      var obj = {}
      that.detailData = response.body
      var list = that.detailData.details
      list.forEach(function (i, index) {
        if (categoryId === '') {
          categoryId = i.categoryId
        }
        if (i.categoryId === categoryId) {
          if (JSON.stringify(obj) === '{}') {
            obj.categoryName = i.categoryName
            obj.item = []
          }
          obj.item.push(i)
          if (index !== (list.length - 1) && i.categoryId !== list[index + 1].categoryId) {
            that.detailItems.push(obj)
            categoryId = list[index + 1].categoryId
            obj = {}
          } else if (index === (list.length - 1)) {
            that.detailItems.push(obj)
          }
        }
      })
    })
  },
  methods: {
    onReset () {
      this.$emit('close', false, false)
    }
  },
  mounted () {
    $('#dialog .el-dialog__body').css('padding', '0px 20px')
  }
}
</script>

<style scoped>
.hb {
    margin: 10px 0;
}
.but {
    height: 35px;
    width: 60px;
    border-radius: 6px;
    margin-left: 10px;
    border: none;
    cursor: pointer;
}
.white_but {
    color: #333;
    background: #fff;
    border: 1px solid #d9d9d9;
}
.title{
    text-align: center;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    border-bottom: 1px solid #ddd;
}

.titleBg{
    display: inline-block;
    background: #fff;
    width: 100%;
    height: 41px;
    margin-top: 8px;
    border-top-right-radius: 49px;
    line-height: 45px;
    padding-left: 15px;
    font-size: 16px;
    box-sizing: border-box;
}

.bg{
    background: #f4f5fa;
}
.timeBox{
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
}
.timeBox i{
    font-style: normal;
}
.content{
    width: calc(100% - 1px);
}
.content tr{
    height: 50px;
}
.content th,.content td{
    border: 1px solid #ddd;
    text-align: center;
    padding-left: 15px;
    text-align: left;
}
.explainTitle {
    width: 180px;
}
</style>


// WEBPACK FOOTER //
// src/components/supervisor/scoreDetail.vue